import { enableMapSet } from 'immer';

export type PromiseWithResolvers<T> = {
  promise: Promise<T>;
  resolve: (value: T | PromiseLike<T>) => void;
  reject: (reason?: any) => void;
};

/**
 * init config, polyfills etc needed across _all_ clients here
 * */
export const initPolyfills = () => {
  if (
    typeof window !== 'undefined' &&
    typeof window.requestIdleCallback === 'undefined'
  ) {
    const p = import('requestidlecallback');
    // Forward calls while polyfill is loading
    // NOTE: Forwarded calls are NOT cancellable
    window.requestIdleCallback = (cb, options) => {
      p.then(() => {
        window.requestIdleCallback.call(window, cb, options);
      });
      // ts expects number return here
      // return invalid id to avoid potential conflict
      return -1;
    };
  }

  // eslint-disable-next-line func-names, @typescript-eslint/no-empty-function, no-empty-function
  if (!(function* () {})()?.map) {
    const POLYFILL = 'iterator-helpers-polyfill';
    /** @ref https://frame-io.slack.com/archives/C6URBDSP8/p1764710905163559 */
    import(POLYFILL);
  }

  if (typeof crypto !== 'undefined' && !crypto.randomUUID) {
    // https://stackoverflow.com/a/2117523
    /* eslint-disable no-bitwise */
    const randomUUID = (): any => {
      return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c) =>
        (
          +c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+c / 4)))
        ).toString(16)
      );
    };
    /* eslint-enable no-bitwise */

    crypto.randomUUID = randomUUID;
  }

  enableMapSet();
};
